import styles from 'styled-components';

const StyledHeading = styles.h3``;

const Heading3 = ({ children, ...rest }) => (
  <StyledHeading {...rest}>{children}</StyledHeading>
);

export default Heading3;
